export const distanceConvertor = (distance: number | string) => {
  if (typeof distance === 'string' && distance.endsWith('km')) {
    return {
      value: Number(distance.replace('km', '')),
      unit: 'km',
    };
  } else {
    const distanceNumber = Number(distance);
    let value = distanceNumber;
    let unit = 'meter';
    if (distanceNumber > 1000) {
      value = Math.ceil(distanceNumber / 100) / 10;
      unit = 'km';
    }

    return {
      value,
      unit,
    };
  }
};
